import Vue from 'vue'
import Router from 'vue-router'

import error404 from '../views/app/error-404'
import error500 from '../views/app/error-500'
import login from '../views/app/login'
import home from '../views/app/home'
import interface_labels from '../views/app/interface_labels'
import opt_labels from '../views/app/opt_labels'
import acc_labels from '../views/app/acc_labels'
import custprg_labels from '../views/app/custprg_labels'
import opt_color_labels from '../views/app/opt_color_labels'
import regole_e9_opt_to_price from '../views/app/regole_e9_opt_to_price'
import tools from '../views/app/tools'
import api_Json_test from '../views/app/api_Json_test'
import editorial_placeholders from '../views/app/editorial_placeholders'
import editorial_contents from '../views/app/editorial_contents'
import countries from '../views/app/settings/countries'
import languages from '../views/app/settings/languages'
import configuration_parameters from '../views/app/settings/configuration_parameters'
import techdata from '../views/app/techdata'
import efficiency_classes from '../views/app/efficiency_classes'
import trackinglabels from '../views/app/settings/trackinglabels'
import car_models from '../views/app/settings/car_models'
import model_grid_management from '../views/app/settings/model_grid_management'
import call_to_action from '../views/app/settings/call_to_action'
import opt_groups from '../views/app/settings/opt_groups'
import interfaceConfig from '../views/app/settings/interface'
import users from '../views/app/settings/users'
import price_configurator from '../views/app/price_configurator/price_configurator'
import pack_configurator from '../views/app/pack_configurator'
import implicit_packs from '../views/app/implicit_packs'
import landing from '../views/app/landing'
import sso from '../views/app/sso'
import solModel from '../views/app/sol_model'
import solCampaign from '../views/app/sol_campaign'
import solCountry from '../views/app/sol_country'
import store from '../store/store'
import country_models from '../views/app/country_models'
import solDownpayment from '../views/app/sol_downpayment'
import check_grid_icon from '../views/app/check_grid_icon'
import grid_rules_check from '../views/app/grid_rules_check'


Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/ccb',
  /*
  https://router.vuejs.org/guide/essentials/history-mode.html#example-server-configurations
  location / {
    try_files $uri $uri/ /index.html;
  }
  */
  linkActiveClass: 'active',
  scrollBehavior: function (to) {    if (to.hash) {      return {        selector: to.hash      }    }  },
  routes: [{
    path: '/',
    name: 'home',
    component: home
  },{
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/price_configurator',
    name: 'price_configurator',
    component: price_configurator
  },
  {
    path: '/pack_configurator',
    name: 'pack_configurator',
    component: pack_configurator
  },
  {
    path: '/implicit_packs',
    name: 'implicit_packs',
    component: implicit_packs,
    props: true
  },
  {
    path: '/interface_labels',
    name: 'interface_labels',
    component: interface_labels,
    props: true
  },
  {
    path: '/opt_labels',
    name: 'opt_labels',
    component: opt_labels,
    props: true
  },
  {
    path: '/acc_labels',
    name: 'acc_labels',
    component: acc_labels,
    props: true
  },
  {
    path: '/custprg_labels',
    name: 'custprg_labels',
    component: custprg_labels,
    props: true
  },
   {
    path: '/opt_color_labels',
    name: 'opt_color_labels',
    component: opt_color_labels,
    props: true
  },
  {
    path: '/regole_e9_opt_to_price',
    name: 'regole_e9_opt_to_price',
    component: regole_e9_opt_to_price,
    props: true
  },
  {
    path: '/editorial_contents',
    name: 'editorial_contents',
    component: editorial_contents,
    props: true
  },
  {
    path: '/techdata',
    name: 'techdata',
    component: techdata,
    props: true
  },
  {
    path: '/efficiency_classes',
    name: 'efficiency_classes',
    component: efficiency_classes,
    props: true
  },
  {
    path: '/editorial_palcehoders',
    name: 'editorial_placeholders',
    component: editorial_placeholders,
    props: true
  },
  {
    path: '/users',
    name: 'users',
    component: users
  },
  {
    path: '/interface',
    name: 'interface',
    component: interfaceConfig
  },
  {
    path: '/countries',
    name: 'countries',
    component: countries,
    props: true
  },
  {
    path: '/languages',
    name: 'languages',
    component: languages,
    props: true
  },
  {
    path: '/configuration_parameters',
    name: 'configuration parameter',
    component: configuration_parameters,
    props: true
  },
  {
    path: '/trackinglabels',
    name: 'Tracking Labels',
    component: trackinglabels,
    props: true
  },  
  {
    path: '/car_models',
    name: 'Car Models',
    component: car_models,
    props: true
  }, 
  {
    path: '/model_grid_management',
    name: 'Model Grid Management',
    component: model_grid_management,
    props: true
  },
  {
    path: '/call_to_action',
    name: 'Call To Action',
    component: call_to_action,
    props: true
  }, 
   {
    path: '/opt_groups',
    name: 'Opt Group',
    component: opt_groups,
    props: true
  }, 
  {
    path: '/tools',
    name: 'tools',
    component: tools,
    props: true
  }, 
  { 
    path: '/api_Json_test',
    name: 'api_Json_test',
    component: api_Json_test,
    props: true
  },
  { 
    path: '/landing',
    name: 'landing',
    component: landing,
    props: true
  },
  { 
    path: '/landingAuth',
    name: 'landingAuth',
    component: landing,
    props: true
  },
  { 
    path: '/sso',
    name: 'sso',
    component: sso,
    props: true
  },
  {
    path: '/404',
    name: 'error-404',
    component: error404
  },
  {
    path: '/500',
    name: 'error-500',
    component: error500
  },
  {
    path: '/sol_model',
    name: 'sol_model',
    component: solModel
  },
  {
    path: '/sol_campaign',
    name: 'sol_campaign',
    component: solCampaign
  },
  {
    path: '/country_models',
    name: 'country_models',
    component: country_models
  },
  {
    path: '/sol_country',
    name: 'sol_country',
    component: solCountry
  },
  {
    path: '/sol_downpayment',
    name: 'sol_downpayment',
    component: solDownpayment
  },
  {
    path: '/icons_check',
    name: 'icons_check',
    component: check_grid_icon,
    props: true
  },
  {
    path: '/grid_rules_check',
    name: 'grid_rules_check',
    component: grid_rules_check
  },
  // otherwise redirect to home
  { path: '*', redirect: '/' }]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.name != 'login' && record.name != 'landing' && record.name != 'sso')) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.state.loginSuccess) {
      next({
        path: '/login'
      })
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
